import { Component, OnInit } from '@angular/core';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/observable/fromEvent';
import { trigger, style, animate, transition } from '@angular/animations';
import { FleetModelAverageHours, JobSite, SelectionLists } from '../../../../entities/global/model';
import { AppService } from '../../../../app.service';
import { NotificationsService } from 'angular2-notifications';
import { DashboardService } from '../../dashboard.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationBoxComponent } from '../../../../shared/confirmation-box/confirmation-box.component';

export class SearchItems {
  constructor(itemPerPage: number) {
    this.PageNumber = 1;
    this.ItemPerPage = itemPerPage;
    this.Recalculate = false;
  }
  public CustomerId: number;
  public JobsiteId: number;
  public MakeId: number;
  public ModelId: number;
  public ItemPerPage: number;
  public PageNumber: number;
  public Recalculate: boolean;
}

@Component({
  selector: 'fleet-view-averages',
  templateUrl: './fleet-view-averages.component.html',
  styleUrls: ['./fleet-view-averages.component.scss'],
  animations: [
    trigger(
      'fadeInOut', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('500ms', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('500ms', style({ opacity: 0 }))
      ])
    ]
    )]
})

export class FleetViewAveragesComponent implements OnInit {

  customerModel: string = "";
  selectedJobsite: JobSite;
  makeModel: string = "";
  machineModel: string = "";
  FleetViewAveragesFiltered: FleetModelAverageHours[] = [];
  recordsPerPage: number = 50;
  pageNumber: number = 0;
  totalResults: number = 0;

  SearchFilter: SearchItems = new SearchItems(this.recordsPerPage);

  isLoading = false;
  showValidation = false;
  isRefreshing = false;

  _dropDownLists: SelectionLists = new SelectionLists();
  _dropDownListsFiltered: SelectionLists = new SelectionLists();

 
  constructor(private _appService: AppService, private _notification: NotificationsService, private _dasboardService: DashboardService, private _dialog: MatDialog) {}

  ngOnInit() {
    this._appService.setPageTitle("Fleet Averages View");

    this._appService.getCustomerListForSelection(1, 10000).subscribe(
      result => {
        this._dropDownLists.customerList = result;

        this._dropDownListsFiltered.customerList = result;
      },
      error => {
        console.error(error);
      },
      () => {
      }
    );
    this._appService.getJobSiteListForSelection(1, 10000).subscribe(
      result => {
        this._dropDownLists.jobSiteList = result;
      },
      error => {
        console.error(error);
      },
      () => {
      }
    );
    this._appService.getMakeListForSelection(1, 10000).subscribe(
      result => {
        this._dropDownLists.makeList = result;
        this._dropDownListsFiltered.makeList = result;
      },
      error => {
        console.error(error);
      },
      () => {
      }
    );
    this._appService.getModelListForSelection(1, 10000).subscribe(
      result => {
        this._dropDownLists.modelList = result;
      },
      error => {
        console.error(error);
      },
      () => {
      }
    );
  }

  ResetFields() {
    
    this.showValidation = false;
    this.resetCustomer();
    this.resetJobsite();
    this.resetMake();
    this.resetModel();
    
    this.FleetViewAveragesFiltered = null;
    this.makeModel = "";
    this.machineModel = "";
    this.customerModel = "";
    this.pageNumber = 0;
    this.recordsPerPage = 50;
    this.totalResults = 0;
  }

  searchRecords(recalculate: boolean) {
    this.pageNumber = 0;
    this.search(recalculate);
  }

  search(recalculate: boolean) {
    this.showValidation = true;
    if (!this.SearchFilter.CustomerId) {
      this._notification.warn('Please select Customer.');
      return;
    }
    else if (!this.SearchFilter.JobsiteId) {
      this._notification.warn('Please select Job Site.');
      return;
    }
    this.isLoading = true;
    this.SearchFilter.Recalculate = recalculate;
    this.SearchFilter.PageNumber = this.pageNumber + 1;
    this.SearchFilter.ItemPerPage = this.recordsPerPage == 0 ? 50 : this.recordsPerPage;
    this._dasboardService.fleetModelAverageHours(this.SearchFilter).subscribe(res => {
      if (res != null && res?.length > 0) {
        this.FleetViewAveragesFiltered = res;
      }
      else {
        this._notification.alert('No record(s) found!');
      }
      this.showValidation = false;
      this.isLoading = false;
    });
   
  }

  recalculate() {
    const dialogRef = this._dialog.open(ConfirmationBoxComponent, {
      disableClose: true,
      data: {
        title: 'Recalculate Averages',
        message: 'Are you sure you want to recalculate the system-calculated values? Any manual adjustments will be overwritten.'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result?.confirmed) {
        this.search(true);
      }
    });
    
  }

  onPageEvent(event: any) {
    this.pageNumber = event.pageIndex;
    this.recordsPerPage = event.pageSize;
    this.search(false);
  }

  changePageSize(size: number) {
    this.recordsPerPage = size;
    this.pageNumber = 0;   // optional
    this.search(false);
  }

  onSelectCustomer(event: any) {
    let id = this._dropDownListsFiltered.customerList.find(f => f.Title == event.value).Id
    //this.customerId = id
    this.SearchFilter.CustomerId = id;
    this._dropDownListsFiltered.jobSiteList = null;
    this._dropDownListsFiltered.jobSiteList = this._dropDownLists.jobSiteList.filter(
      m => m.CustomerId === id
    );
  }

  customerChanged(event: any) {
    if (event.target.value != "") {
      const filterValue = event.target.value.toLowerCase();
      this._dropDownListsFiltered.customerList = this._dropDownLists.customerList.filter(option => option.Title.toLowerCase().includes(filterValue));
    }
    else {
      this.resetModel();
      this.resetMake();
    }

  }

  jobsiteChanged(event: any): void {
    this.selectedJobsite = event.value;
    if (!this.selectedJobsite) {
      return;
    }
    //this.jobsite = this.selectedJobsite.Id;
    this.SearchFilter.JobsiteId = this.selectedJobsite.Id;
    //if (event.target)
    //  this.jobsite = event.target.value;
    this.resetModel();
    this.resetMake();
  }

  onSelectMake(event: any) {
    let id = this._dropDownListsFiltered.makeList.find(f => f.Title == event.value).Id
    this.SearchFilter.MakeId = id;
    this._dropDownListsFiltered.modelList = this._dropDownLists.modelList.filter(
      m => m.MakeId === id
    );
  }

  changedMake(event: any) {
    if (event.target) {
      const filterValue = event.target.value.toLowerCase();
      this._dropDownListsFiltered.makeList = this._dropDownLists.makeList.filter(option => option.Title.toLowerCase().includes(filterValue));
    }
  }

  onSelcetionModel(event: any) {
    let id = this._dropDownListsFiltered.modelList.find(f => f.Title == event.value).Id
    this.SearchFilter.ModelId = id;
  }

  changedModel(event: any) {
    if (event.target.value != "") {
      const filterValue = event.target.value.toLowerCase();
      this._dropDownListsFiltered.modelList = this._dropDownLists.modelList.filter(option => option.Title.toLowerCase().includes(filterValue));
    }
    else {
      this.resetModel();
    }
  }

  resetCustomer() {
    //this.SearchFilter.CustomerId = 0;
    //this.selectedCustomer = null;
    this._dropDownListsFiltered.customerList = this._dropDownLists.customerList;
  }

  resetJobsite() {
    //this.SearchFilter.JobsiteId = 0;
    this.selectedJobsite = null;
    this._dropDownListsFiltered.jobSiteList = this._dropDownLists.jobSiteList;
  }

  resetMake() {
    //this.SearchFilter.MakeId = 0;
    //this.selectedMake = null;
    this._dropDownListsFiltered.makeList = this._dropDownLists.makeList;
  }

  resetModel() {
    //this.SearchFilter.ModelId = 0;
    //this.selectedModel = null;
    this._dropDownListsFiltered.modelList = this._dropDownLists.modelList;
  }

  public validateFilters(): boolean {

    if (!this.customerModel || this.customerModel.trim() === '') {
      this._notification.warn('Please select a Customer');
      return false;
    }

    if (!this.selectedJobsite) {
      this._notification.warn('Please select a Jobsite');
      return false;
    }

    return true;
  }

  editAverage(item: FleetModelAverageHours) {
    item.isEditing = true;
    item.oldAverageMonthlyHours = item.AverageMonthlyHours;
    item.oldAveragePropelHours = item.AveragePropelHours;
  }

  saveAverage(item: FleetModelAverageHours) {
    this._dasboardService.adjustfleetModelAverageHours(item).subscribe(result => {
      if (result) {
        item.isEditing = false;
        item.oldAverageMonthlyHours = undefined;
        item.oldAveragePropelHours = undefined;
      }
      else
        this._notification.error('Error', 'Error while saving data, Please contact Tracktreads Support.');
    });
  }

  cancelAverage(item: FleetModelAverageHours) {

    item.AverageMonthlyHours = item.oldAverageMonthlyHours;
    item.AveragePropelHours = item.oldAveragePropelHours;

    item.isEditing = false;
  }


}
